// Libs
import { createSelector } from 'reselect'
import _filter from 'lodash/filter'

// Selectors
import getAllRequests$ from './getAllRequests'

// Constants
import { PROP_STATUS } from '../constants'

export default (status) => createSelector(
  [getAllRequests$],
  (requests) => _filter(requests, (request) => request[PROP_STATUS] === status)
)
